/**
 * Waitlist Service (Public Booking)
 * Allows guests to join the waitlist when no slots are available
 */

import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface WaitlistFormData {
  customerName: string;
  customerPhone: string;
  customerEmail?: string;
  selectedDays: string[];
  barberPreference: 'any' | string;
  barberName?: string;
  timePreference: 'any' | 'morning' | 'afternoon' | 'evening';
  textNotifications: boolean;
}

class WaitlistService {
  private collectionName = 'waitlist';

  /**
   * Add guest to waitlist
   */
  async addToWaitlist(data: WaitlistFormData): Promise<string> {
    const entry: Record<string, any> = {
      customerName: data.customerName,
      customerPhone: data.customerPhone.replace(/\D/g, ''), // Normalize phone
      days: data.selectedDays,
      barberPreference: data.barberPreference,
      timePreference: data.timePreference || 'any',
      textNotifications: data.textNotifications ?? true,
      status: 'waiting',
      createdAt: Timestamp.now(),
      source: 'public-booking',
    };

    // Only add optional fields if they have values
    if (data.customerEmail) entry.customerEmail = data.customerEmail;
    if (data.barberName) entry.barberName = data.barberName;

    const docRef = await addDoc(collection(db, this.collectionName), entry);
    console.log('📋 Added to waitlist:', docRef.id);
    return docRef.id;
  }
}

export const waitlistService = new WaitlistService();
export default waitlistService;
